/* addon.js - Added 6/12/2017 3:00pm BK */

/*!
 * enquire.js v2.1.6 - Awesome Media Queries in JavaScript
 * Copyright (c) 2017 Nick Williams - http://wicky.nillia.ms/enquire.js
 * License: MIT */

!function(a){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=a();else if("function"==typeof define&&define.amd)define([],a);else{var b;b="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,b.enquire=a()}}(function(){return function a(b,c,d){function e(g,h){if(!c[g]){if(!b[g]){var i="function"==typeof require&&require;if(!h&&i)return i(g,!0);if(f)return f(g,!0);var j=new Error("Cannot find module '"+g+"'");throw j.code="MODULE_NOT_FOUND",j}var k=c[g]={exports:{}};b[g][0].call(k.exports,function(a){var c=b[g][1][a];return e(c?c:a)},k,k.exports,a,b,c,d)}return c[g].exports}for(var f="function"==typeof require&&require,g=0;g<d.length;g++)e(d[g]);return e}({1:[function(a,b,c){function d(a,b){this.query=a,this.isUnconditional=b,this.handlers=[],this.mql=window.matchMedia(a);var c=this;this.listener=function(a){c.mql=a.currentTarget||a,c.assess()},this.mql.addListener(this.listener)}var e=a(3),f=a(4).each;d.prototype={constuctor:d,addHandler:function(a){var b=new e(a);this.handlers.push(b),this.matches()&&b.on()},removeHandler:function(a){var b=this.handlers;f(b,function(c,d){if(c.equals(a))return c.destroy(),!b.splice(d,1)})},matches:function(){return this.mql.matches||this.isUnconditional},clear:function(){f(this.handlers,function(a){a.destroy()}),this.mql.removeListener(this.listener),this.handlers.length=0},assess:function(){var a=this.matches()?"on":"off";f(this.handlers,function(b){b[a]()})}},b.exports=d},{3:3,4:4}],2:[function(a,b,c){function d(){if(!window.matchMedia)throw new Error("matchMedia not present, legacy browsers require a polyfill");this.queries={},this.browserIsIncapable=!window.matchMedia("only all").matches}var e=a(1),f=a(4),g=f.each,h=f.isFunction,i=f.isArray;d.prototype={constructor:d,register:function(a,b,c){var d=this.queries,f=c&&this.browserIsIncapable;return d[a]||(d[a]=new e(a,f)),h(b)&&(b={match:b}),i(b)||(b=[b]),g(b,function(b){h(b)&&(b={match:b}),d[a].addHandler(b)}),this},unregister:function(a,b){var c=this.queries[a];return c&&(b?c.removeHandler(b):(c.clear(),delete this.queries[a])),this}},b.exports=d},{1:1,4:4}],3:[function(a,b,c){function d(a){this.options=a,!a.deferSetup&&this.setup()}d.prototype={constructor:d,setup:function(){this.options.setup&&this.options.setup(),this.initialised=!0},on:function(){!this.initialised&&this.setup(),this.options.match&&this.options.match()},off:function(){this.options.unmatch&&this.options.unmatch()},destroy:function(){this.options.destroy?this.options.destroy():this.off()},equals:function(a){return this.options===a||this.options.match===a}},b.exports=d},{}],4:[function(a,b,c){function d(a,b){var c=0,d=a.length;for(c;c<d&&b(a[c],c)!==!1;c++);}function e(a){return"[object Array]"===Object.prototype.toString.apply(a)}function f(a){return"function"==typeof a}b.exports={isFunction:f,isArray:e,each:d}},{}],5:[function(a,b,c){var d=a(2);b.exports=new d},{2:2}]},{},[5])(5)});

/**
 *
 * Match Media Polyfill for IE9 Support
 *
 */

window.matchMedia||(window.matchMedia=function(){"use strict";var e=window.styleMedia||window.media;if(!e){var t=document.createElement("style"),n=document.getElementsByTagName("script")[0],d=null;t.type="text/css",t.id="matchmediajs-test",n?n.parentNode.insertBefore(t,n):document.head.appendChild(t),d="getComputedStyle"in window&&window.getComputedStyle(t,null)||t.currentStyle,e={matchMedium:function(e){var n="@media "+e+"{ #matchmediajs-test { width: 1px; } }";return t.styleSheet?t.styleSheet.cssText=n:t.textContent=n,"1px"===d.width}}}return function(t){return{matches:e.matchMedium(t||"all"),media:t||"all"}}}());

!function(){if(window.matchMedia&&window.matchMedia("all").addListener)return!1;var e=window.matchMedia,n=e("only all").matches,i=!1,t=0,a=[],r=function(n){clearTimeout(t),t=setTimeout(function(){for(var n=0,i=a.length;n<i;n++){var t=a[n].mql,r=a[n].listeners||[],o=e(t.media).matches;if(o!==t.matches){t.matches=o;for(var c=0,d=r.length;c<d;c++)r[c].call(window,t)}}},30)};window.matchMedia=function(t){var o=e(t),c=[],d=0;return o.addListener=function(e){n&&(i||(i=!0,window.addEventListener("resize",r,!0)),0===d&&(d=a.push({mql:o,listeners:c})),c.push(e))},o.removeListener=function(e){for(var n=0,i=c.length;n<i;n++)c[n]===e&&c.splice(n,1)},o}}();

$(document).ready(function() {

    // For code organization purposes, let's use Object Literal Notation

    var DomModifier = {

        // Start your Engines

        home: {

            initHomeSlider: function() {

                var ctaText = "ENROLL TODAY";
                var headingText = "Online Driver’s Ed Courses";

                $('#homeSlider #myCarousel a').remove();

                $('.orangeBar #mystate2').prepend('<optgroup label="Select a State">');
                $('.orangeBar #mystate2').append('</optgroup>');

                $('.select-state').attr("style", "display:none;visibility:hidden");
                $('.select-state').hide();

                $('#homeSlider .span8:nth-child(3), #homeSlider .slide-head').addClass('span12').removeClass('span8');
                $('#homeSlider a').removeClass('btn-danger btn-small').addClass('btn-large');
                $('#homeSlider .hidden-phone').removeClass('hidden-phone');
                $('#myCarousel .carousel-caption h3.slide-title1').text(headingText);
                $('#homeSlider a').text(ctaText);
                $('#homeSlider .span4, #homeSlider #myCarousel .item:nth-child(2), #homeSlider #myCarousel .item:nth-child(3), #homeSlider img, #homeSlider .slide-head').remove();

            }, // homeSlider

            initNewHamburgerMenu: function() {
                $('#mainNav .btn-navbar').remove();
                $('.home-logo .mobile-login-btn').append('<a class="hamburger collapsed btn" href="#" id="nav-icon1" data-toggle="collapse" data-target=".navbar-responsive-collapse"><span></span><span></span><span></span></a>');
            }, // homeLogo

            initSocialIcons: function() {
                $('.social a > img').remove();
                // Facebook
                $('.social a:nth-child(1)').append('<img src="//d33lidpmi8tua9.cloudfront.net/img/facebook-icon-e1430750834501.jpg">');
                // Twitter
                $('.social a:nth-child(2)').append('<img src="//d33lidpmi8tua9.cloudfront.net/img/twitter-copy-e1430750896594.jpg">');
                // Linkedin
                $('.social a:nth-child(3)').append('<img src="//d33lidpmi8tua9.cloudfront.net/img/linkedin-copy-e1430752710857.jpg">');
                // Google Plus
                $('.social a:nth-child(4)').append('<img src="//d33lidpmi8tua9.cloudfront.net/img/google-plus-e1430750885711.png">');
            }, // socialIcons

            initMediaQueries: function() {

                    // Uses default bootstrap media query sizes.
                    // Uses enquire.js

                    function addSliderDesktop() {

                        $('#homeSlider #myCarousel .item:nth-child(1)').append('<img class="bg-image" src="//d33lidpmi8tua9.cloudfront.net/img/slider1.jpg"/>');
                        $('#homeSlider #myCarousel .item .carousel-caption h3').append('<img class="aplus" src="https://www.dmv.com/sites/default/files/cybera/driveredtogo/frontend/img/aplus.png"/>');
                        $('.slide-title1 .selectContainer').remove();
                        $('.slide-title1').append('<div class="selectContainer"></div>');
                        $('.home-states-dropdown select').clone().attr('id','state-slider').addClass('statedropdown btn btn-large btn-warning').appendTo('.slide-title1 .selectContainer');
                        $('.slide-title1 .selectContainer').append('<img src="//d33lidpmi8tua9.cloudfront.net/img/right-arrow.svg"/>');
                        $('.slide-title1 .select-state').text("ENROLL TODAY");
                        $('.slide-title1 .statedropdown').prepend('<optgroup label="Select a State">');
                        $('.slide-title1 .statedropdown').append('</optgroup>');
                        $('.slide-title1 .statedropdown').change(function () {
                                location.href = $(this).val() + '-online-driver-education.aspx';
                        });
                    }

                    function addSliderMobile() {
                        $('.slide-title1 .selectContainer').remove();
                        $('#homeSlider #myCarousel .item:nth-child(1)').append('<img class="bg-image" src="//d33lidpmi8tua9.cloudfront.net/img/slider-mobile2.jpg"/>');
                        $('#homeSlider #myCarousel .item .carousel-caption h3').append('<img class="aplus" src="//d33lidpmi8tua9.cloudfront.net/img/aplus-mobile.png"/>');
                    }

                    function emptySlider() {
                        $('#homeSlider .selectContainer').remove();
                        $('.slide-title1 .selectContainer').remove();
                        $('#homeSlider .aplus').remove();
                        $('#homeSlider #myCarousel .item:nth-child(1) .bg-image').remove();
                    }

                    var ctaButton = $('#myCarousel .carousel-caption a.btn'),
                        ctaSelect = $('.orangeBar #mystate2');

                    enquire.register("(max-width: 480px)", {
                        deferSetup : true,
                        match: function() {
                            emptySlider();
                            addSliderMobile();
                            $('#myCarousel .carousel-caption').append('<div class="selectContainer"></div>')
                            $(ctaSelect).appendTo("#myCarousel .carousel-caption .selectContainer");
                            $('.carousel-caption .btn').css({ 'display': 'none' });
                            $('#myCarousel #mystate2').css({ 'display': 'block' }).addClass('btn btn-large btn-warning');
                            $('#myCarousel .carousel-caption .selectContainer').append('<img src="//d33lidpmi8tua9.cloudfront.net/img/right-arrow.svg"/>');

                            $('#myCarousel .select-state').html('ENROLL TODAY');
                        },
                        unmatch: function() {
                            emptySlider();
                            addSliderMobile();
                        }
                    });

                    enquire.register("(min-width: 480px) and (max-width: 991px)", {
                        match: function() {
                            emptySlider();
                            addSliderDesktop();
                        },
                        unmatch: function() {
                            emptySlider();
                            addSliderMobile();
                        }
                    });

                    enquire.register("(min-width: 992px) and (max-width: 1199px)", {
                        match: function() {
                            emptySlider();
                            addSliderDesktop();
                        },
                        unmatch: function() {
                            emptySlider();
                            addSliderDesktop();
                        }
                    });

                    enquire.register("(min-width: 1200px)", {
                        match: function() {
                            emptySlider();
                            addSliderDesktop();
                        },
                        unmatch: function() {
                            emptySlider();
                            addSliderDesktop();
                        }
                    });
                } // mediaQueries

        }, // home

        intro: {

            initNewHamburgerMenu: function() {
                $('.main-header .seo-nav').addClass('mobile-login-btn').append('<a class="hamburger collapsed btn" href="#" id="nav-icon1" data-toggle="collapse" data-target=".main-nav"><span></span><span></span><span></span></a>');
                $('.navbar-header .navbar-toggle').remove();
                // $('.navbar-header').append('<p class="navbar-text-white visible-xs-inline-block">Over 12 Years of Educating Teens</p>');
            },

            initMediaQueries: function() {

                enquire.register("(max-width: 480px)", {
                    deferSetup : true,
                    match: function() {
                        $('.seo-nav .resp-login-btn').removeClass('visible-sm-block visible-xs-block').addClass('btn-sm');
                        $('.seo-nav.mobile-login-btn .resp-login-btn').prepend('<i class="fa fa-user"></i>');
                        $('.bg-container a.btn-danger').removeClass('btn-danger btn-md').addClass('btn-warning btn-lg').append('<img class="bg-image" src="//d33lidpmi8tua9.cloudfront.net/img/right-arrow.svg"/>');
                        $('.prep-wizard-mod a.btn-danger').removeClass('btn-danger btn-md').addClass('btn-primary btn-lg btn-block');
                        $('.prep-wizard-mod .col-md-4:nth-child(1)').empty().append('<img class="bg-image" src="//d33lidpmi8tua9.cloudfront.net/img/icon1.svg"/>');
                        $('.extra-credit-mod .col-md-3:nth-child(1)').empty().append('<img class="bg-image" src="//d33lidpmi8tua9.cloudfront.net/img/icon2.svg"/>');
                        $('.extra-credit-mod a.btn-danger').removeClass('btn-danger btn-md').addClass('btn-primary btn-lg btn-block');
                        $('.jumbotron-price-text').addClass('text-success');
                        $('.col-sm-4.left-module.module').hide();
                        $('.bg-container a.btn-warning').clone().insertBefore(".main-content.license-procedure p:nth-child(5)").removeClass('btn btn-lg btn-warning text-center').addClass('btn-link');
                        $('.bg-container a.btn-warning').clone().insertBefore(".main-content.license-procedure p:nth-child(11)").removeClass('btn btn-lg btn-warning text-center').addClass('btn-link');
                        $('.bg-container a.btn-warning').clone().insertBefore(".main-content.license-procedure p:nth-child(23)").removeClass('btn btn-lg btn-warning text-center').addClass('btn-link');

                        var buttonContentOriginal = $('.jumbotron-price-text').text();
                        var buttonContent = buttonContentOriginal.replace("–", "for ");

                        $('.main-content.license-procedure .btn-link').empty().text('Get your ' + buttonContent);
                        $('.main-content.license-procedure .btn-link').append('- Register now');

                    },
                    unmatch: function() {
                        $('.seo-nav .resp-login-btn').addClass('visible-sm-block visible-xs-block');
                        $('a.btn-primary').removeClass('btn-primary').addClass('btn-danger');
                        $('.jumbotron-price-text').removeClass('text-success');
                    }
                });
            } // mediaQueries

        }, // intro

        step1: {
            initSteps: function() {

                steps_html = '<div class="text-center bs-wizard-title">Select Product</div>';
                steps_html += '<div class="row bs-wizard">';
                steps_html += '    <div class="span4 bs-wizard-step complete">';
                //steps_html += '      <div class="text-center bs-wizard-stepnum">Step 1</div>';
                steps_html += '      <div class="progress"><div class="progress-bar"></div></div>';
                steps_html += '      <a href="#" class="bs-wizard-dot"></a>';
                steps_html += '    </div>';
                steps_html += '    <div class="span4 bs-wizard-step active"><!-- complete -->';
                //steps_html += '      <div class="text-center bs-wizard-stepnum">Step 2</div>';
                steps_html += '      <div class="progress"><div class="progress-bar"></div></div>';
                steps_html += '      <a href="#" class="bs-wizard-dot"></a>';
                steps_html += '    </div>';
                steps_html += '    <div class="span4 bs-wizard-step active"><!-- complete -->';
                //steps_html += '      <div class="text-center bs-wizard-stepnum">Step 3</div>';
                steps_html += '      <div class="progress"><div class="progress-bar"></div></div>';
                steps_html += '      <a href="#" class="bs-wizard-dot"></a>';
                steps_html += '    </div>';
                steps_html += '    <div class="span4 bs-wizard-step active"><!-- active -->';
                //steps_html += '      <div class="text-center bs-wizard-stepnum">Step 4</div>';
                steps_html += '      <div class="progress"><div class="progress-bar"></div></div>';
                steps_html += '      <a href="#" class="bs-wizard-dot"></a>';
                steps_html += '    </div>';
                steps_html += '</div>';

            },

            initMediaQueries: function() {
                deferSetup : true,
                enquire.register("(max-width: 480px)", {
                    match: function() {
                      $('.reg-steps').hide();
                      $('h2.course-head').parent().html(steps_html);
                      $('.product-btn-continue').removeClass('btn-danger').addClass('btn-primary btn-block');
                      $('#main-content').css('background', '#F5F5F5');

                      $('#main-content .container .container').append('<div class="sticky-cta"></div>');
                      $('#main-content .container .container .row:nth-child(3)').appendTo(".sticky-cta");
                      $('#main-content form').css('margin-bottom', '80px');


                      // Replace all <div>'s with <label>'s
                      $('.package').replaceWith(function() {
                        return '<label class="package">'+$(this).html()+'</label>';
                      });

                    },

                    unmatch: function() {
                      $('.reg-steps').show();
                      $('.bs-wizard').remove();
                    }
                });
            }
        }, // Step1

        step2: {
            initSteps: function() {

                steps_html = '<div class="text-center bs-wizard-title">Shipping Method</div>';
                steps_html += '<div class="row bs-wizard">';
                steps_html += '    <div class="span4 bs-wizard-step complete">';
                //steps_html += '      <div class="text-center bs-wizard-stepnum">Step 1</div>';
                steps_html += '      <div class="progress"><div class="progress-bar"></div></div>';
                steps_html += '      <a href="#" class="bs-wizard-dot"></a>';
                steps_html += '    </div>';
                steps_html += '    <div class="span4 bs-wizard-step complete"><!-- complete -->';
                //steps_html += '      <div class="text-center bs-wizard-stepnum">Step 2</div>';
                steps_html += '      <div class="progress"><div class="progress-bar"></div></div>';
                steps_html += '      <a href="#" class="bs-wizard-dot"></a>';
                steps_html += '    </div>';
                steps_html += '    <div class="span4 bs-wizard-step active"><!-- complete -->';
                //steps_html += '      <div class="text-center bs-wizard-stepnum">Step 3</div>';
                steps_html += '      <div class="progress"><div class="progress-bar"></div></div>';
                steps_html += '      <a href="#" class="bs-wizard-dot"></a>';
                steps_html += '    </div>';
                steps_html += '    <div class="span4 bs-wizard-step active"><!-- active -->';
                //steps_html += '      <div class="text-center bs-wizard-stepnum">Step 4</div>';
                steps_html += '      <div class="progress"><div class="progress-bar"></div></div>';
                steps_html += '      <a href="#" class="bs-wizard-dot"></a>';
                steps_html += '    </div>';
                steps_html += '</div>';

            },

            initMediaQueries: function() {

                $("#ctl00_MainContent_rblSameDayProcessing_1").removeAttr('checked');
                $("#ctl00_MainContent_rblSameDayProcessing_0").prop('checked', true);

                deferSetup : true,
                enquire.register("(max-width: 480px)", {
                    match: function() {
                      $('.reg-steps').hide();
                      $('.ship-head').parent().html(steps_html);
                      $('.btn-danger.btn-large').removeClass('btn-danger').addClass('product-btn-continue btn-primary btn-block');
                      $('.reg-shipping-options, .reg-same-day').addClass('well');
                      $('#main-content').css('background', '#F5F5F5');
                      $('.read-along-headphones').remove();
                      $('.ship-shopping-cart').insertBefore(".ship .text-right");
                    },

                    unmatch: function() {
                      $('.reg-steps').show();
                      $('.bs-wizard').remove();
                    }
                });
            }
        }, // Step 2

        step3: {
            initSteps: function() {

                steps_html = '<div class="text-center bs-wizard-title" style="margin-top:0px">Registration</div>';
                steps_html += '<div class="row bs-wizard">';
                steps_html += '    <div class="span4 bs-wizard-step complete">';
                //steps_html += '      <div class="text-center bs-wizard-stepnum">Step 1</div>';
                steps_html += '      <div class="progress"><div class="progress-bar"></div></div>';
                steps_html += '      <a href="#" class="bs-wizard-dot"></a>';
                steps_html += '    </div>';
                steps_html += '    <div class="span4 bs-wizard-step complete"><!-- complete -->';
                //steps_html += '      <div class="text-center bs-wizard-stepnum">Step 2</div>';
                steps_html += '      <div class="progress"><div class="progress-bar"></div></div>';
                steps_html += '      <a href="#" class="bs-wizard-dot"></a>';
                steps_html += '    </div>';
                steps_html += '    <div class="span4 bs-wizard-step complete"><!-- complete -->';
                //steps_html += '      <div class="text-center bs-wizard-stepnum">Step 3</div>';
                steps_html += '      <div class="progress"><div class="progress-bar"></div></div>';
                steps_html += '      <a href="#" class="bs-wizard-dot"></a>';
                steps_html += '    </div>';
                steps_html += '    <div class="span4 bs-wizard-step active"><!-- active -->';
                //steps_html += '      <div class="text-center bs-wizard-stepnum">Step 4</div>';
                steps_html += '      <div class="progress"><div class="progress-bar"></div></div>';
                steps_html += '      <a href="#" class="bs-wizard-dot"></a>';
                steps_html += '    </div>';
                steps_html += '</div>';

            },

            initMediaQueries: function() {

                deferSetup : true,
                enquire.register("(max-width: 480px)", {
                    match: function() {
                      $('#main-content').css('background', '#F5F5F5');
                      $('#main-content').css('margin-bottom', '60px');
                      $('.login-box').parent().prepend(steps_html);
                      $('.btn-danger').removeClass('btn-danger').addClass('product-btn-continue btn-primary btn-large btn-block');
                      $('a.oauth').empty;
                      $('a.oauth > img').remove();
                      $('a.oauth').append('<img width="220" src="//d33lidpmi8tua9.cloudfront.net/img/fb-logo.png">');
                    },

                    unmatch: function() {
                      $('.reg-steps').show();
                      $('.bs-wizard').remove();
                    }
                });
            }
        }, // Step 3

        step4: {
            initSteps: function() {

                steps_html = '<div class="text-center bs-wizard-title" style="margin-top:-10px">Registration</div>';
                steps_html += '<div class="row bs-wizard">';
                steps_html += '    <div class="span4 bs-wizard-step complete">';
                //steps_html += '      <div class="text-center bs-wizard-stepnum">Step 1</div>';
                steps_html += '      <div class="progress"><div class="progress-bar"></div></div>';
                steps_html += '      <a href="#" class="bs-wizard-dot"></a>';
                steps_html += '    </div>';
                steps_html += '    <div class="span4 bs-wizard-step complete"><!-- complete -->';
                //steps_html += '      <div class="text-center bs-wizard-stepnum">Step 2</div>';
                steps_html += '      <div class="progress"><div class="progress-bar"></div></div>';
                steps_html += '      <a href="#" class="bs-wizard-dot"></a>';
                steps_html += '    </div>';
                steps_html += '    <div class="span4 bs-wizard-step complete"><!-- complete -->';
                //steps_html += '      <div class="text-center bs-wizard-stepnum">Step 3</div>';
                steps_html += '      <div class="progress"><div class="progress-bar"></div></div>';
                steps_html += '      <a href="#" class="bs-wizard-dot"></a>';
                steps_html += '    </div>';
                steps_html += '    <div class="span4 bs-wizard-step active"><!-- active -->';
                //steps_html += '      <div class="text-center bs-wizard-stepnum">Step 4</div>';
                steps_html += '      <div class="progress"><div class="progress-bar"></div></div>';
                steps_html += '      <a href="#" class="bs-wizard-dot"></a>';
                steps_html += '    </div>';
                steps_html += '</div>';

            },

            initMediaQueries: function() {

                deferSetup : true,
                enquire.register("(max-width: 480px)", {
                    match: function() {
                        $('.reg-form').parent().prepend(steps_html);
                        $('.enroll.course-head').removeClass('course-head').addClass('alert alert-success');
                        $('dl.dl-horizontal').addClass('well');
                        $('#main-content').css('background', '#F5F5F5');
                        $('.btn-primary').addClass('btn-large');
                    },

                    unmatch: function() {

                    }
                });
            }
        }, // Step 4

        step5: {
            initSteps: function() {

                steps_html = '<div class="text-center bs-wizard-title" style="margin-top:-10px">Payment</div>';
                steps_html += '<div class="row bs-wizard">';
                steps_html += '    <div class="span4 bs-wizard-step complete">';
                //steps_html += '      <div class="text-center bs-wizard-stepnum">Step 1</div>';
                steps_html += '      <div class="progress"><div class="progress-bar"></div></div>';
                steps_html += '      <a href="#" class="bs-wizard-dot"></a>';
                steps_html += '    </div>';
                steps_html += '    <div class="span4 bs-wizard-step complete"><!-- complete -->';
                //steps_html += '      <div class="text-center bs-wizard-stepnum">Step 2</div>';
                steps_html += '      <div class="progress"><div class="progress-bar"></div></div>';
                steps_html += '      <a href="#" class="bs-wizard-dot"></a>';
                steps_html += '    </div>';
                steps_html += '    <div class="span4 bs-wizard-step complete"><!-- complete -->';
                //steps_html += '      <div class="text-center bs-wizard-stepnum">Step 3</div>';
                steps_html += '      <div class="progress"><div class="progress-bar"></div></div>';
                steps_html += '      <a href="#" class="bs-wizard-dot"></a>';
                steps_html += '    </div>';
                steps_html += '    <div class="span4 bs-wizard-step complete"><!-- active -->';
                //steps_html += '      <div class="text-center bs-wizard-stepnum">Step 4</div>';
                steps_html += '      <div class="progress"><div class="progress-bar"></div></div>';
                steps_html += '      <a href="#" class="bs-wizard-dot"></a>';
                steps_html += '    </div>';
                steps_html += '</div>';

            },

            initMediaQueries: function() {

                deferSetup : true,
                enquire.register("(max-width: 480px)", {
                    match: function() {
                        $('.reg-steps,.ship-head').hide();
                        $('#main-content').css('background', '#F5F5F5');
                        $('.reg-later').appendTo('#ctl00_MainContent_panelPayLater');
                        $('.reg-form').parent().prepend(steps_html);
                        $('.enroll.course-head').removeClass('course-head').addClass('alert alert-success');
                        $('.btn.btn-info').removeClass('btn-info').addClass('btn-primary');
                        $('dl.dl-horizontal').addClass('well');
                        $('#ctl00_MainContent_panelPayCheck').prependTo(".reg-form.container");
                        $('#ctl00_MainContent_panelPayLater').prependTo(".reg-form.container");
                        $('#makePayment_register .span9').addClass('well');
                        $('.btn-row.marginTop40').removeClass('btn-row');
                        $('.btn-danger').addClass('btn-block');
                        $('#ctl00_MainContent_hlPayCheck').addClass('pull-right');
                        $('#makePayment_register .span9 .control-group:first').addClass('alert alert-warning');
                        $('.notices .well').removeClass('well').addClass('alert alert-warning');
                        $('#ctl00_MainContent_requiredAddress1, #ctl00_MainContent_requiredCity').remove();
                    },

                    unmatch: function() {
                        $('.reg-steps,.ship-head').show();
                    }
                });
            }
        }, // Step 5

        step6: {
            initSteps: function() {

                steps_html = '<div class="text-center bs-wizard-title">Payment</div>';
                steps_html += '<div class="row bs-wizard">';
                steps_html += '    <div class="span4 bs-wizard-step complete">';
                //steps_html += '      <div class="text-center bs-wizard-stepnum">Step 1</div>';
                steps_html += '      <div class="progress"><div class="progress-bar"></div></div>';
                steps_html += '      <a href="#" class="bs-wizard-dot"></a>';
                steps_html += '    </div>';
                steps_html += '    <div class="span4 bs-wizard-step complete"><!-- complete -->';
                //steps_html += '      <div class="text-center bs-wizard-stepnum">Step 2</div>';
                steps_html += '      <div class="progress"><div class="progress-bar"></div></div>';
                steps_html += '      <a href="#" class="bs-wizard-dot"></a>';
                steps_html += '    </div>';
                steps_html += '    <div class="span4 bs-wizard-step complete"><!-- complete -->';
                //steps_html += '      <div class="text-center bs-wizard-stepnum">Step 3</div>';
                steps_html += '      <div class="progress"><div class="progress-bar"></div></div>';
                steps_html += '      <a href="#" class="bs-wizard-dot"></a>';
                steps_html += '    </div>';
                steps_html += '    <div class="span4 bs-wizard-step complete"><!-- active -->';
                //steps_html += '      <div class="text-center bs-wizard-stepnum">Step 4</div>';
                steps_html += '      <div class="progress"><div class="progress-bar"></div></div>';
                steps_html += '      <a href="#" class="bs-wizard-dot"></a>';
                steps_html += '    </div>';
                steps_html += '</div>';

            },

            initMediaQueries: function() {

                deferSetup : true,
                enquire.register("(max-width: 480px)", {
                    match: function() {
                        $('.reg-form').parent().prepend(steps_html);
                        $('.enroll.course-head').removeClass('course-head').addClass('alert alert-success');
                        $('dl.dl-horizontal').addClass('well');
                        $('.reg-steps,.ship-head').hide();
                        $('.row.btn-row').removeClass('btn-row');
                        $('#main-content').css('background', '#F5F5F5');
                        $('.btn-danger').removeClass('btn-danger').addClass('product-btn-continue btn-success btn-large btn-block');
                    },

                    unmatch: function() {
                        $('.reg-steps,.ship-head').show();
                    }
                });
            }
        }, // Step 6

        step6failed: {

            initMediaQueries: function() {

                enquire.register("(max-width: 480px)", {
                    match: function() {
                        $('.reg-text').addClass('alert alert-danger');
                        $('#main-content').css('background', '#F5F5F5');
                    },

                    unmatch: function() {
                        $('.reg-steps,.ship-head').show();
                    }
                });
            }
        } // Step 6

    }; // DomModifier

    // Homepage
    if ($('#ctl00_Head1').is('*')) {
        DomModifier.home.initHomeSlider();
        DomModifier.home.initNewHamburgerMenu();
        DomModifier.home.initSocialIcons();
        DomModifier.home.initMediaQueries();
    }

    // Intro Page
    if ($('#sectionJumbo').is('*')) {
        DomModifier.intro.initNewHamburgerMenu();
        DomModifier.intro.initMediaQueries();
    }

    // Step1 - Product Selector
    if ($('form[action^="./default"]').is('*')) {
        DomModifier.home.initNewHamburgerMenu();
        DomModifier.step1.initSteps();
        DomModifier.step1.initMediaQueries();
    }

    // Step2 - Shipping Information
    if ($('form[action^="./Ship"]').is('*')) {
        DomModifier.step2.initSteps();
        DomModifier.step2.initMediaQueries();
    }

    // Step3 - User Information
    if ($('form[action^="./User"]').is('*')) {
        DomModifier.step3.initSteps();
        DomModifier.step3.initMediaQueries();
    }

    // Step4 - Registration Receipt
    if ($('form[action^="./SkipRegisterReceipt"]').is('*')) {
        DomModifier.step4.initSteps();
        DomModifier.step4.initMediaQueries();
    }

    // Step5 - Payment
    if ($('form[action^="./Payment"]').is('*')) {
        DomModifier.step5.initSteps();
        DomModifier.step5.initMediaQueries();
    }

    // Step6 - Success
    if ($('form[action^="./Receipt"]').is('*')) {
        DomModifier.step6.initSteps();
        DomModifier.step6.initMediaQueries();
    }

    // Step6 - Declined
    if ($('form[action^="./PaymentDeclined"]').is('*')) {
        DomModifier.step6failed.initMediaQueries();
    }

});

// End addon.js
